import { FelaCSS, FelaCSSWithCustomSelectors } from '../../components/fela/flowtypes';
import { colors } from '../../themes/variables';

export interface FileUploaderStyles {
  fileUploader?: FelaCSSWithCustomSelectors;
  plusIcon?: FelaCSS;
  uploadInfo?: FelaCSS;
  content?: FelaCSS;
}

const standardUploaderStyles = (): FileUploaderStyles => ({
  fileUploader: {
    '> div': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      color: colors.indigoCrush,
      cursor: 'pointer',
      justifyContent: 'center',
      textAlign: 'center',
      paddingTop: '20px',
      paddingBottom: '20px',
      paddingLeft: '20px',
      paddingRight: '20px',
      borderColor: `${colors.space40}`,
      borderStyle: 'dashed',
      borderWidth: '1px',
      borderRadius: '16px',
      width: '100%',
      height: 'auto',
    },
  },
  plusIcon: {
    justifyContent: 'center',
    alignItems: 'center',
    width: 20,
    height: 20,
    borderRadius: '50%',
    border: `1px solid ${colors.indigoCrush}`,
  },
  uploadInfo: {
    fontDefault: 14,
    color: colors.space40,
  },
  content: {
    justifyContent: 'center',
    alignItems: 'center',
    gap: '12px',
  },
});

export default standardUploaderStyles;
